module.exports = __webpack_public_path__ + "img/breitenberg.20aa8ab0.jpg";